"use client";

import { useEffect } from "react";

const WIDGET_SCRIPT_ID = "learners-point-chat-widget";
const WIDGET_SCRIPT_SRC =
  "https://chat.learnerspoint.org/lp-assistant.js";

const BitrixScript = () => {
  useEffect(() => {
    const existingScript = document.getElementById(WIDGET_SCRIPT_ID);
    if (existingScript) return undefined;

    const script = document.createElement("script");
    script.id = WIDGET_SCRIPT_ID;
    script.src = WIDGET_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  // Previous custom chat widget is disabled in favor of the hosted LP assistant script.
  return null;
};

export default BitrixScript;
